import { Injectable } from '@angular/core';
import { UserService } from '@cms_root/app/core/services/user.service';
import { Role } from '../models/role';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  constructor(private readonly userService: UserService) {}

  public hasRole$(roles: Role[]): Observable<boolean> {
    return this.userService.roles$.pipe(map((userRoles) => userRoles.some((userRole) => roles.includes(userRole))));
  }

  public hasRole(roles: Role[]): boolean {
    return this.userService.roles.some((userRole) => roles.includes(userRole));
  }
}
